module.exports = __webpack_public_path__ + "img/coldtruck.2a0ae157.png";